import { useAppDispatch, useAppSelector } from '../../../app/store';
import { useEffect } from 'react';
import { getCollaborators, getCommitteeMembers, getConveners, getDealingOfficers, getForwardingAuthorities, getInvestigators, getIOAppointingAuthorities, getSupervisingAuthorityUsers } from './slice';
import { fetchCommitteeMembers, fetchConveners, fetchDealingOfficers, fetchForwardingAuthorities, fetchIOAppointingAuthorities } from './thunk';
import { fetchUsersByRoles } from '../../configs/logic/Thunks';


export const useConveners = () => {
  const dispatch = useAppDispatch();
  const conveners = useAppSelector(getConveners);

  useEffect(() => {
    if (conveners.length === 0) {
      dispatch(fetchConveners());
    }
  }, [dispatch, conveners.length]);

  return conveners;
};

export const useCommitteeMembers = () => {
  const dispatch = useAppDispatch();
  const members = useAppSelector(getCommitteeMembers);

  useEffect(() => {
    if (members.length === 0) {
      dispatch(fetchCommitteeMembers());
    }
  }, [dispatch, members.length]);

  return members;
};

export const useDealingOfficers = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(getDealingOfficers);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchDealingOfficers());
    }
  }, [dispatch, data.length]);

  return data;
};

export const useIOAppointingAuthorities = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(getIOAppointingAuthorities);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchIOAppointingAuthorities());
    }
  }, [dispatch, data.length]);

  return data;
};

export const useForwardingAuthorities = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(getForwardingAuthorities);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchForwardingAuthorities());
    }
  }, [dispatch, data.length]);

  return data;
};

export const useInvestigators = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(getInvestigators);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchUsersByRoles());
    }
  }, [dispatch, data.length]);

  return data;
};

export const useCollaborators = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(getCollaborators);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchUsersByRoles());
    }
  }, [dispatch, data.length]);

  return data;
};

export const useSupervisingAuthorities = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(getSupervisingAuthorityUsers);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(fetchUsersByRoles());
    }
  }, [dispatch, data.length]);

  return data;
};
